import React from "react";

const SubHeading = ({ SubHeading, className = "" }) => {
  return (
    <p className={`type-body-large text-left md:text-center ${className}`}>
      {SubHeading}
    </p>
  );
};

export default SubHeading;
